import clsx from "clsx"
import React, { useEffect } from "react"
import { useState } from "react"

interface CheckboxProps {
  className?: string,
  onChange?: (e: any) => void,
  id?: string,
  value?: string,
  hasError?: boolean,
  disabled?: boolean
  name?: string,
  checked?: boolean,
  labelClassName?: string,
  label?: string
}


const Checkbox = React.forwardRef(({ label, labelClassName, checked, className, onChange, id, hasError, disabled, value, name }: CheckboxProps, ref: React.LegacyRef<HTMLInputElement> | undefined) => {
  const [isChecked, setIsChecked] = useState(false)

  return (
    <div className="h-[20px] flex content-start items-start">
      <div className={clsx('relative inline-block h-full w-[16px]', className)}>
        <input
          id={id}
          type="checkbox"
          className="hidden"
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          value={value}
          ref={ref}
          name={name}
        />
        <div
          className={
            clsx("absolute h-[16px] w-[16px] top-0 bottom-0 border flex justify-center items-center",
              hasError ? "border-coral" : "border-onyx",
              disabled && 'border-silver bg-pearl',
              (isChecked || checked) && 'bg-onyx text-white')
          }
          onClick={() => {
            onChange
            setIsChecked(!isChecked)
          }}
        >
          {(isChecked || checked) && '✓'}
        </div>
      </div>
      <div
        onClick={() => {
          onChange
          setIsChecked(!isChecked)
        }}
        className={clsx('align-top capitalize inline-block cursor-pointer', labelClassName)}
      >
        <span className="align-top">{label}</span>
      </div>
    </div>
  )
}
)

Checkbox.displayName = 'Checkbox';

export default Checkbox
